import status from "../constants/actionStatus";

const initialState = {
    status: status.NONE,
    isVisible: false,
};

export default function bottomBarReducer(state = initialState, action = {}) {
    switch (action.type) {
    case "TOGGLE_BOTTOM_BAR_REQUEST":
        return {
            ...state,
            status: status.PENDING,
        };
    case "TOGGLE_BOTTOM_BAR_SUCCESS":
        return {
            ...state,
            status: status.SUCCESS,
            isVisible: action.payload,
        };
    case "TOGGLE_BOTTOM_BAR_FAILURE":
        return {
            ...state,
            status: status.ERROR,
        };
    default:
        return state;
    }
}
